/**
 * Weergave-only helper: leidt het echte min/max in PERSONEN af zoals de engine.
 * Gebruikt het geexporteerde berekenBezettingsDoel uit rooster-engine.js als ENIGE
 * bron van de formule (geen kopie meer). GEEN engine-/data-wijziging — puur voor
 * de Beheer-weergave, zodat die toont wat de engine echt afdwingt.
 */
import { berekenBezettingsDoel } from '../engine/rooster-engine.js';

// min = berekenBezettingsDoel(d, false), max = berekenBezettingsDoel(d, true) — engine-formule.
export function bezettingPersonen(dienst, koppelGrootte = 2) {
  const kg = koppelGrootte || 2;
  const min = berekenBezettingsDoel(dienst, false, kg);
  const max = berekenBezettingsDoel(dienst, true, kg);
  return { min, max, oneven: !!dienst.oneven_toegestaan };
}

// Label ALTIJD in personen, voor elke dienst hetzelfde — geen koppel-deel meer, want
// bezetting wordt in personen ingesteld: "3 personen" bij een vast aantal, "3–6 personen"
// bij een marge. oneven_toegestaan speelt hier geen rol meer.
export function bezettingLabel(dienst, koppelGrootte = 2) {
  const { min, max } = bezettingPersonen(dienst, koppelGrootte);
  if (min === max) return `${min} ${min === 1 ? 'persoon' : 'personen'}`;
  return `${min}–${max} personen`;
}
